import {
  all, put, select, takeEvery
} from "redux-saga/effects";

import { get, STORAGE_KEYS, save } from "API/LocalStorage";
import {
  projectsRelevanceSuccess, uiUsernamesAdd, uiUsernamesLoad, uiUsernamesRemove
} from "Store/Actions";
import { selectUsernames, selectLoginUsername } from "Store/Selectors/UI";
import { hasNoElements } from "Utils/Array";

function* loadUsernamesSaga() {
  let usernames = get<string[]>(STORAGE_KEYS.USERNAMES);

  if (hasNoElements(usernames)) {
    usernames = [];
  }

  const loginUsername = yield select(selectLoginUsername);
  yield put(uiUsernamesAdd([...usernames, loginUsername]));
}

function* usernamesAddOrRemoveSaga() {
  const usernames = yield select(selectUsernames);
  save(STORAGE_KEYS.USERNAMES, usernames);
  yield put(projectsRelevanceSuccess());
}

export function* UsernamesSaga(): unknown {
  yield all([
    takeEvery(uiUsernamesLoad, loadUsernamesSaga),
    takeEvery([uiUsernamesAdd, uiUsernamesRemove], usernamesAddOrRemoveSaga)
  ]);
}
